export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/joe-gardner-1-55217dafd6f5e00e4b65637961a0f16d.jpg";